module.exports = __webpack_public_path__ + "img/143.0190cf62.jpg";